import { render, staticRenderFns } from "./SrButtonGroup.vue?vue&type=template&id=1e80839b"
import script from "./SrButtonGroup.vue?vue&type=script&lang=js"
export * from "./SrButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports